export default "__VITE_PUBLIC_ASSET__2cb03aa4__"